module.exports = __webpack_public_path__ + "img/quanjia.57318b3f.png";